import { fetchFamilyInfo } from '../../family/familyInfoApi';

export type FamilyMemberCandidate = {
  empFamilyId: number;
  fullName: string;
  relationship: string;
  claimedByOtherIncome: boolean;
  otherEarnerName: string;
  otherEarnerAddress: string;
};

export async function fetchOtherIncomeMemberCandidates(email: string): Promise<FamilyMemberCandidate[]> {
  const res = await fetchFamilyInfo(email);
  const members = res.members ?? [];
  return members
    .filter((m) => m.id != null && (m.fullName?.trim() ?? '') !== '')
    .map((m) => ({
      empFamilyId: m.id!,
      fullName: m.fullName?.trim() ?? '',
      relationship: (m.relationship ?? '').trim().toLowerCase(),
      claimedByOtherIncome: m.claimedByOtherIncome === true,
      otherEarnerName: m.otherEarnerName?.trim() ?? '',
      otherEarnerAddress: m.otherEarnerAddress?.trim() ?? '',
    }));
}

export function otherIncomeEarnerCursor(step: string): string {
  return `otherIncomeEarner:${step}`;
}
